<div>
  <app-page>
    <div class="top-cta" *ngIf="isAuthenticated">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      @if(editingMode) {
      <dx-drop-down-button
        [splitButton]="true"
        [text]="'COMMON.SAVE' | translate"
        stylingMode="contained"
        type="normal"
        [dropDownOptions]="{ width: 230 }"
        (onButtonClick)="submit()"
      >
        <dxi-item (click)="deleteStandardCategory()">{{
          "COMMON.DELETE" | translate
        }}</dxi-item>
      </dx-drop-down-button>
      } @else {
        <dx-button
          class="cta-btn"
          type="normal"
          [text]="'COMMON.SAVE' | translate"
          (click)="submit()"
        ></dx-button>
      }
    </div>
    <app-page-title
      [title]="
        editingMode
          ? ('STANDARD-CATEGORIES.ADMIN.TITLE-EDIT' | translate)
          : ('STANDARD-CATEGORIES.ADMIN.TITLE-ADD' | translate)
      "
    ></app-page-title>

    <app-admin-login
      *ngIf="!isAuthenticated && isLoaded"
      (loginSuccess)="onLoginSuccess()"
    ></app-admin-login>

    <div class="row" *ngIf="isAuthenticated || !isLoaded">
      <div class="col-md-12 col-lg-5">
        <app-panel class="image-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="category-image"
              [src]="formData.image"
              *ngIf="formData.image"
            />
            <img
              class="category-image"
              src=""
              appTrainingImageFallback
              *ngIf="!formData.image && editingMode"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!formData.image && !editingMode"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useForm"
            [visible]="false"
            (valueChange)="onStandardCategoryImageSelected($event)"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel [title]="'ADMINISTRATION.GENERAL' | translate">
          <dx-form
            #generalForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="formData"
          >
            <dxi-item
              dataField="type"
              editorType="dxSelectBox"
              [editorOptions]="typeSelectOptions"
            >
              <dxo-label [text]="'COMMON.FIELDS.TYPE' | translate"></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.TYPE-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>

            <dxi-item
              dataField="parentId"
              editorType="dxSelectBox"
              [editorOptions]="parentSelectOptions"
            >
              <dxo-label 
                [text]="'COMMON.FIELDS.PARENT' | translate"
              ></dxo-label>
            </dxi-item>
          </dx-form>
        </app-panel>

        <app-panel
          class="training-category-panel"
          [title]="'ADMINISTRATION.TITLE-DESCRIPTION' | translate"
        >
          <dx-select-box
            [items]="languageOptions"
            displayExpr="name"
            valueExpr="id"
            [(value)]="selectedLanguageCode"
            (onValueChanged)="onLanguageChanged($event)"
            stylingMode="outlined"
          >
          </dx-select-box>

          <dx-form #form
            *ngIf="selectedTranslation"
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="selectedTranslation"
          >
            <dxi-item dataField="name">
              <dxo-label
                [text]="'COMMON.FIELDS.NAME' | translate"
              ></dxo-label>

              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>

            <dxi-item
              dataField="description"
              [editorType]="'dxTextArea'"
              [label]="{ text: ('COMMON.FIELDS.DESCRIPTION' | translate) }"
              [editorOptions]="{
                placeholder: ('COMMON.FIELDS.DESCRIPTION' | translate),
                height: 160
              }"
            ></dxi-item>
          </dx-form>
        </app-panel>
      </div>
      <div class="col-md-12">
        <app-panel 
          *ngIf="selectedTranslation"
          [title]="'ADMINISTRATION.EXTENDED-DESCRIPTION' | translate"
        >
           <app-expandable-text-editor
            
            [(value)]="selectedTranslation.descriptionExtended"
          ></app-expandable-text-editor>
        </app-panel>
      </div>
    </div>
  </app-page>
</div>
